import _ from "lodash";

const IS_CLIENT = typeof window !== "undefined";

//server
const appBridge = IS_CLIENT ? require("./client").default : require("./server").default;

// 原代码用法无法兼容 server（依赖了模块执行），手动区分兼容
export default appBridge;

// android 2.7.7(周伟) iOS 2.1.1(黄婷婷)，开始支持在 user-agent 上提供 akulaku/version
// android 2.8.0(徐小威) iOS 2.1.3(曾森源)，开始随一个 HTTP 请求，在 cookie 上提供 sessionId 和 countryCode 等
// TODO 待重构和抽取 bridge 体系

// isAkulaku 系列，不要直接从 app-bridge 使用，转而从 env 上使用

// app 标识符，用于区分不同业务线
const APP_IDENTITY_NAME = "akulaku";

const rawIsAkulakuRef = appBridge.isAkulaku;
/**
 * 调整 iaAkulaku 定义，优先从 ua 上获取，再从原 bridge 机制获取
 * @param {Object} [req=undefined] 服务器使用时需提供 req
 * @returns {boolean|undefined} 确定是否在 app 时返回 true|false，不确定时返回 undefined(仅服务器端)
 */
const newIsAkulaku = function({ req } = {}) {
  const uaAppInfo = parseAppInfoByUserAgent({ req });
  if (uaAppInfo) {
    return true;
  } else {
    // ua 上无法解析，可能是旧版本 app，也可能是非 app 环境
    // TODO 支持 ua 的版本全覆盖后，可不再考虑此情况
    if (!IS_CLIENT) {
      // 服务端时视为未知
      return undefined;
    } else {
      // 浏览器端使用原判断机制
      return rawIsAkulakuRef();
    }
  }
};
appBridge.isAkulaku = newIsAkulaku;
appBridge.isAkulakuAndroid = function({ req } = {}) {
  const isAkulaku = newIsAkulaku({ req });
  if (isAkulaku === true) {
    return /\bAndroid\b/i.test(getUserAgent(req));
  } else {
    return false;
  }
};
appBridge.isAkulakuIOS = function({ req } = {}) {
  const isAkulaku = newIsAkulaku({ req });
  if (isAkulaku === true) {
    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
    return /\biPad|iPhone|iPod\b/.test(getUserAgent(req));
  } else {
    return false;
  }
};
appBridge.parseAppInfoByUserAgent = parseAppInfoByUserAgent;

/**
 * 从 ua 解析 app 版本信息
 * 在 server 端，仅能通过 ua 判断是否在 app 内
 * 在 browser 端，从 ua 的判断，时间点早于 bridge 初始化
 * 可将 ua 视为总是存在的常量
 *
 * @return {object | undefined} 确定是返回 object，不能确定时返回 undefined
 */
function parseAppInfoByUserAgent({ req } = {}) {
  const ua = getUserAgent(req);

  if (!ua) {
    return undefined
  }
  // /(?:\s|^)akulaku\/(.+?)(?:\s|$)/
  // 需确保 appName 不包含正则表达式的特殊字符
  const reg = new RegExp(`(?:\\s|^)(akulaku|silvrrplus|wisecart)\\/(.+?)(?:\\s|$)`);

  let version;
  let appName;
  ua.replace(reg, ($0, $1, $2) => {
    appName = $1;
    version = $2;
  });

  if (version) {
    return {
      appName,
      version,
    };
  } else {
    return undefined;
  }
}

function getUserAgent(req) {
  if (!IS_CLIENT) {
    if (!req) {
      throw new Error("server 端调用时必须提供 req");
    }
    return req.headers["user-agent"];
  } else {
    return navigator.userAgent;
  }
}

